const e = {
  rowsPerPage: "Rows per Page"
};
export {
  e as default
};
